export default "__VITE_ASSET__eb7a8577__"